// TYPES
import { Children } from '@/types/common.types';

// CONSTANTS
import { ROUTE_ROOT_PRIVATE } from '@/constants/routes';

// COMPONENTS
import Redirect from '@/components/Redirect';

interface Props {
  component: Children;
  isAuth: boolean;
}

const PublicRoute = ({ component, isAuth }: Props) => {
  if (isAuth) {
    return (
      <Redirect
        to={{
          pathname: ROUTE_ROOT_PRIVATE,
          state: { from: '' },
        }}
      />
    );
  }

  return <>{component}</>;
};

export default PublicRoute;
